import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { NotificacaoFiltersInput } from '@aksape/validators';
import { notificacoesApi } from '../api/notificacoes.api';

export const NOTIFICACOES_KEYS = {
  all: ['notificacoes'] as const,
  list: (filters: Partial<NotificacaoFiltersInput>) => ['notificacoes', 'list', filters] as const,
  count: ['notificacoes', 'nao-lidas-count'] as const,
};

export function useNotificacoesList(filters: Partial<NotificacaoFiltersInput>) {
  return useQuery({
    queryKey: NOTIFICACOES_KEYS.list(filters),
    queryFn: () => notificacoesApi.list(filters),
    staleTime: 15_000,
  });
}

// Poll leve — não há push/websocket nesta sprint (fora de escopo), só
// refetch periódico do contador para o sino de notificações.
export function useNaoLidasCount() {
  return useQuery({
    queryKey: NOTIFICACOES_KEYS.count,
    queryFn: () => notificacoesApi.countNaoLidas(),
    staleTime: 15_000,
    refetchInterval: 60_000,
  });
}

export function useMarcarLida() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => notificacoesApi.marcarLida(id),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: NOTIFICACOES_KEYS.all }),
  });
}

export function useMarcarTodasLidas() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => notificacoesApi.marcarTodasLidas(),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: NOTIFICACOES_KEYS.all }),
  });
}
